import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReduxState } from 'reducers/root.reducer'
import { SimpleMap } from '@vendorflow/types'
import { forEach } from 'lodash'
import { selectActiveUser } from 'features/auth/Auth.slice'
import { DisplayEnum } from 'pages/WorkspacePage/Configurations/Device/DeviceSettings.constants'
import { MapTypesEnum } from 'features/maps/Maps.constants'

export interface State {
  users: SimpleMap<{ shortcuts: { sideNavWorkspaces: { enabled: boolean } } }>
  displayMode: DisplayEnum
  mapType: MapTypesEnum
}

export const initialState: State = {
  users: {},
  displayMode: DisplayEnum.DEFAULT,
  mapType: MapTypesEnum.DEFAULT,
}

const slice = createSlice({
  name: 'page/workspace/settings',
  initialState,
  reducers: {
    setSideNavWorkspacesEnabled(state, action: PayloadAction<{ userId: string; enabled: boolean }>) {
      const { userId, enabled } = action.payload
      traversePath(state, ['users', userId, 'shortcuts', 'sideNavWorkspaces'])
      state.users[userId].shortcuts.sideNavWorkspaces.enabled = enabled
    },
    setDisplayMode(state, action: PayloadAction<DisplayEnum>) {
      state.displayMode = action.payload
    },
    setMapType(state, action: PayloadAction<MapTypesEnum>) {
      state.mapType = action.payload
    },
  },
})

export const { setSideNavWorkspacesEnabled, setDisplayMode, setMapType } = slice.actions

export type Action = ReturnType<typeof setSideNavWorkspacesEnabled>

export default slice.reducer

export const selectUserSettings = (state: ReduxState) => state.settings.users

export const selectSideNavWorkspacesEnabled = createSelector(selectUserSettings, selectActiveUser, (users, userId) => {
  if (!userId) return true

  const enabled = users[userId]?.shortcuts?.sideNavWorkspaces?.enabled
  return enabled == null ? true : enabled
})
export const selectDisplayMode = (state: ReduxState) => state.settings.displayMode
export const selectMapType = (state: ReduxState) => state.settings.mapType

function traversePath(state: State, path: string[]) {
  let cursor = state
  forEach(path, (key: string) => {
    // @ts-ignore
    if (!cursor.hasOwnProperty(key)) cursor[key] = {}
    // @ts-ignore
    cursor = cursor[key]
  })
}
